import { useState } from 'react';

export const usePagination = (itemsPerPage = 10, data?: Array<any>, totalRows = 0) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(totalRows);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
    const pagesCount = Math.ceil((data?.length || total) / itemsPerPage) || 0;

    return { currentPage, setCurrentPage, currentItems, pagesCount, setTotal, total };
};
